import { ReactElement } from "react";

export default function Maintenance(): ReactElement {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f3f4f6",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <h1 style={{ fontSize: "24px", fontWeight: "bold", color: "#374151" }}>
        メンテナンス中です・・・
      </h1>
    </div>
  );
}
